module.exports = __webpack_public_path__ + "static/img/10.987dc41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/10.png
// module id = ma/D
// module chunks = 0